!function () {
  'use strict';

  const selectors = {
    root: 'customer-reviews',
    slide: '[data-customer-reviews-slide]',
    prev: '[data-customer-reviews-prev]',
    next: '[data-customer-reviews-next]',
    counter: '[data-customer-reviews-counter]',
    nav: '[data-customer-reviews-nav]',
  };

  function initSlider(root) {
    const slides = root.querySelectorAll(selectors.slide);
    const nav = root.querySelector(selectors.nav);
    if (!slides.length) return;

    if (slides.length <= 1) {
      if (nav) nav.hidden = true;
      return;
    }

    if (!nav || nav.dataset.customerReviewsReady === 'true') return;

    const prevBtn = nav.querySelector(selectors.prev);
    const nextBtn = nav.querySelector(selectors.next);
    const counter = nav.querySelector(selectors.counter);
    let current = 0;

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        slide.hidden = i !== current;
      });

      if (counter) {
        counter.textContent = `${current + 1}/${slides.length}`;
      }
    };

    nav.dataset.customerReviewsReady = 'true';
    nav.hidden = false;

    prevBtn.addEventListener('click', () => showSlide(current - 1));
    nextBtn.addEventListener('click', () => showSlide(current + 1));
    showSlide(0);
  }

  if (!customElements.get('customer-reviews')) {
    customElements.define(
      'customer-reviews',
      class CustomerReviews extends HTMLElement {
        connectedCallback() {
          initSlider(this);
        }
      }
    );
  }
}();
